import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-check',
  templateUrl: './health-check.component.html',
  styleUrls: ['./health-check.component.scss']
})
export class HealthCheckComponent implements OnInit {

  status: string;

  constructor() { }

  ngOnInit(): void {
    this.status = 'OK';
  }

}